"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetProductsTotalCountByFilter = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const client_utils_1 = require("../../client.utils");
const get_products_total_count_by_filter_query_1 = require("../gql/get-products-total-count-by-filter.query");
const store_1 = require("../../../../store");
const useGetProductsTotalCountByFilter = ({ catalogId, productTreeNodeId, options, filter, }) => {
    var _a, _b, _c, _d;
    const productTreeId = (0, store_1.useProductTreeId)();
    const shouldSkipProductsCountQuery = !catalogId || !productTreeNodeId || !productTreeId || (options === null || options === void 0 ? void 0 : options.skip);
    const queryVariables = (0, react_1.useMemo)(() => ({
        catalogId,
        productTreeNodeId,
        filter,
    }), [catalogId, filter, productTreeNodeId]);
    const [executeProductsTotalCountQuery, { data, error, networkStatus, refetch, variables, }] = (0, react_2.useLazyQuery)(get_products_total_count_by_filter_query_1.GET_PRODUCTS_TOTAL_COUNT_BY_FILTER, {
        fetchPolicy: (_a = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _a !== void 0 ? _a : 'no-cache',
    });
    const triggerFetchProductsTotalCount = (0, react_1.useCallback)(() => {
        if (shouldSkipProductsCountQuery) {
            return;
        }
        void executeProductsTotalCountQuery({ variables: queryVariables });
    }, [executeProductsTotalCountQuery, queryVariables, shouldSkipProductsCountQuery]);
    return {
        fetchProductsTotalCount: triggerFetchProductsTotalCount,
        lastVariables: variables,
        refetch,
        networkStatus,
        isLoading: !shouldSkipProductsCountQuery && (0, client_utils_1.isQueryLoading)(networkStatus),
        totalCount: (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.productTreeNode) === null || _b === void 0 ? void 0 : _b.productPresentationsNew) === null || _c === void 0 ? void 0 : _c.totalCount) !== null && _d !== void 0 ? _d : 0,
        error,
    };
};
exports.useGetProductsTotalCountByFilter = useGetProductsTotalCountByFilter;
